import { requestTransformer } from "@api/requestTransformer";
import axios from "axios";
import Cookies from "js-cookie";

let cookieDomain;
let community;
let baseUrl = '';
let apiUrl = `${window.location.protocol}//${window.location.hostname}/api/`;//'/api/';

let communityUrl;

// TODO: change this to env vars
if(window.location.host.indexOf('localhost') !== -1) {
    cookieDomain = 'localhost';
    baseUrl = 'http://localhost:3000';
    apiUrl = 'http://demo.maestrocm.local/api/';// 'http://localhost:80/api/';
    communityUrl = 'http://%subdomain%.maestrocm.local';
} else if(window.location.host.indexOf('.local') !== -1) {
    cookieDomain = 'maestrocm.local';
    // baseUrl = '';
    // apiUrl = 'http://demo.maestrocm.local/api/';// 'http://localhost:80/api/';
    //apiUrl = `${window.location.protocol}//${window.location.hostname}/api/`;
    communityUrl = 'http://%subdomain%.maestrocm.local:3000';
} else if(window.location.host.indexOf('.staging') !== -1) {
    cookieDomain = 'staging.maestrocm.com';
    communityUrl = 'https://%subdomain%.staging.maestrocm.com';
} else if(window.location.host.indexOf('.local') !== -1 || window.location.host.indexOf('localhost') !== -1) {
    cookieDomain = 'maestrocm.local';
    communityUrl = 'http://%subdomain%.maestrocm.local';
    // apiUrl = '//' + window.location.host + '/api/';
} else {
    cookieDomain = 'maestrocm.com';
    communityUrl = 'https://%subdomain%.maestrocm.com';
}

if(!community) {
    community = window.location.host.split(cookieDomain)[0];
}

//relationshipUrl = communityUrl.replace('%subdomain%', props.community);

//https://stackoverflow.com/a/52171480
const TSH=s=>{for(var i=0,h=9;i<s.length;)h=Math.imul(h^s.charCodeAt(i++),9**9);return h^h>>>9};

const tokenName = 'mm-token-'+Math.abs(TSH(cookieDomain));
const impersonatingTokenName = 'mm-token-'+Math.abs(TSH(cookieDomain))+'-imp';

let isImpersonating = false;
let token = '';
const getAccessToken = () => {
    if(token !== '') {
        return token;
    }

    // check for impersonate first
    let checkTokenImp = Cookies.get(impersonatingTokenName);
    if(checkTokenImp/* !== null*/) {
        isImpersonating = true;
        token = checkTokenImp;
        return token;
    }

    // let checkToken = localStorage.getItem(tokenName);
    let checkToken = Cookies.get(tokenName);
    if(checkToken) {
        try {
            const parsed = JSON.parse(checkToken);
            token = parsed?.access_token || checkToken;
        } catch (e) {
            token = checkToken;
        }
    }

    return token;
}

const unauthenticatedApi = axios.create({
    baseURL: apiUrl,
});

const authenticatedApi = axios.create({
    baseURL: apiUrl,
    headers: {
        Authorization: {
            toString() {
                return `Bearer ${getAccessToken()}`
            }
        }
    },
    transformRequest: [
        requestTransformer, // this fixes dates
        ...axios.defaults.transformRequest,
    ]
});

const setAccessToken = (accessToken) => {
    // localStorage.setItem(tokenName, accessToken);
    Cookies.set(tokenName, accessToken, {
        domain: cookieDomain,
        expires: 30, // require login every 30 days
    });
    token = accessToken;

    authenticatedApi.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

    return true;
}

/*
let settings = null;
const loadSettings = () => {
    if(settings !== null) return;

    unauthenticatedApi.get(`/settings`).then((response) => {
        // console.log(response);
    });
}
*/

const serialize = (params, prefix) => {
    const query = Object.keys(params).map((key) => {
      const value  = params[key];

      if (params.constructor === Array)
        key = `${prefix}[]`;
      else if (params.constructor === Object)
        key = (prefix ? `${prefix}[${key}]` : key);

      if (typeof value === 'object')
        return serialize(value, key);
      else
        return `${key}=${encodeURIComponent(value)}`;
    });

    return [].concat.apply([], query).join('&');
};

const subdomain = window.location.host.split('.')[0];
const tenantUnawareApiUrl = apiUrl.replace(`${subdomain}`, 'app');

export {
    cookieDomain,
    baseUrl,
    apiUrl,
    tenantUnawareApiUrl,
    // adminUrl,
    communityUrl,

    tokenName,
    impersonatingTokenName,
    isImpersonating,

    getAccessToken,
    setAccessToken,

    serialize,

    unauthenticatedApi,
    authenticatedApi,
};
